import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "veronese:panel-layout"

export default class extends Controller {
  static targets = ["sidebar", "detail"]
  static values = { id: String }

  connect() {
    const saved = this.#load()
    if (saved.sidebarHidden) this.#collapse("sidebar", false)
    if (saved.detailHidden)  this.#collapse("detail", false)
    this.#updateButtons()
  }

  toggleSidebar() {
    const hidden = this.sidebarTarget.classList.contains("panel--collapsed")
    hidden ? this.#expand("sidebar") : this.#collapse("sidebar")
    this.#save()
    this.#updateButtons()
  }

  toggleDetail() {
    const hidden = this.detailTarget.classList.contains("panel--collapsed")
    hidden ? this.#expand("detail") : this.#collapse("detail")
    this.#save()
    this.#updateButtons()
  }

  // private

  #collapse(panel, animate = true) {
    const el = this[`${panel}Target`]
    if (!animate) el.style.transition = "none"
    el.classList.add("panel--collapsed")
    if (!animate) requestAnimationFrame(() => { el.style.transition = "" })
  }

  #expand(panel) {
    this[`${panel}Target`].classList.remove("panel--collapsed")
  }

  #updateButtons() {
    const sidebarHidden = this.hasSidebarTarget &&
      this.sidebarTarget.classList.contains("panel--collapsed")
    const detailHidden = this.hasDetailTarget &&
      this.detailTarget.classList.contains("panel--collapsed")

    this.element.querySelectorAll("[data-panel-toggle='sidebar']").forEach(btn => {
      btn.classList.toggle("panel-toggle-btn--active", !sidebarHidden)
    })
    this.element.querySelectorAll("[data-panel-toggle='detail']").forEach(btn => {
      btn.classList.toggle("panel-toggle-btn--active", !detailHidden)
    })
  }

  #storageKey() {
    return `${STORAGE_KEY}:${this.idValue || "default"}`
  }

  #save() {
    try {
      localStorage.setItem(this.#storageKey(), JSON.stringify({
        sidebarHidden: this.hasSidebarTarget &&
          this.sidebarTarget.classList.contains("panel--collapsed"),
        detailHidden: this.hasDetailTarget &&
          this.detailTarget.classList.contains("panel--collapsed")
      }))
    } catch {}
  }

  #load() {
    try {
      return JSON.parse(localStorage.getItem(this.#storageKey())) || {}
    } catch { return {} }
  }
}
